import { Helmet } from "react-helmet-async";

const SITE = "https://signiastylettoix.com";

export default function Seo({
    title,
    description,
    canonical,
    ogImage = "https://cdn.signia.net/-/media/signia/global/images/products/signia-ix/styletto-ix/styletto-ix_black-silver_double_charger_1920x1080.jpg",
    schema = null,
    noindex = false,
}) {
    const url = canonical || (typeof window !== "undefined" ? `${SITE}${window.location.pathname}` : SITE);
    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={url} />
            <meta property="og:type" content="website" />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:site_name" content="signiastylettoix.com" />
            <meta name="twitter:card" content="summary_large_image" />
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={ogImage} />
            {schema && (
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            )}
        </Helmet>
    );
}

// ---- Schema builders ----
export const orgSchema = () => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "signiastylettoix.com",
    alternateName: "Signia Styletto IX Specialist Store · Powered by HearClear",
    url: SITE,
    logo: `${SITE}/og-cover.jpg`,
    sameAs: ["https://hearclear.in"],
    contactPoint: [{
        "@type": "ContactPoint",
        telephone: "+91-98884-38843",
        contactType: "customer service",
        areaServed: "IN",
        availableLanguage: ["en", "hi"],
    }],
});

export const productSchema = (product) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.name,
    image: product.image,
    description: product.description,
    sku: product.slug,
    brand: { "@type": "Brand", name: "Signia" },
    offers: {
        "@type": "Offer",
        url: `${SITE}/products/${product.slug}`,
        priceCurrency: "INR",
        price: product.price,
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        seller: { "@type": "Organization", name: "HearClear" },
    },
});

export const faqSchema = (faqs) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (faqs || []).map((f) => ({
        "@type": "Question",
        name: f.question || f.q,
        acceptedAnswer: { "@type": "Answer", text: f.answer || f.a },
    })),
});

export const breadcrumbSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((i, idx) => ({
        "@type": "ListItem",
        position: idx + 1,
        name: i.name,
        item: i.url,
    })),
});

export const localBusinessSchema = (city, type = "LocalBusiness") => ({
    "@context": "https://schema.org",
    "@type": type,
    name: `HearClear ${city} — Signia Styletto IX Specialist`,
    url: `${SITE}/seo/signia-styletto-${city.toLowerCase()}`,
    image: "https://cdn.signia.net/-/media/signia/global/images/products/signia-ix/styletto-ix/styletto-ix_black-silver_double_charger_1920x1080.jpg",
    telephone: "+91-98884-38843",
    priceRange: "₹₹₹",
    address: { "@type": "PostalAddress", addressLocality: city, addressCountry: "IN" },
    medicalSpecialty: "Audiology",
});
